var component = require('../../../lib/js/component.js');
var Chart = require('chart.js');

function InteractiveLmpCalculator() {

	var _this;

	var MORTGAGE_TYPES = {
		FHA_30_YEAR_FIXED: 'fha 30 year fixed',
		CONVENTIONAL_30_YEAR_FIXED: 'conventional 30 year fixed',
		CONVENTIONAL_15_YEAR_FIXED: 'conventional 15 year fixed'
	};

	var mortgageTypeConfig = {};
    
    mortgageTypeConfig[MORTGAGE_TYPES.FHA_30_YEAR_FIXED] = {
	 minDownpayment: 3.5,
	 months: 360,
     miFactors: [
      { maxLoan: 726200, factor: 0.0055 },
      { minLoan: 726201, factor: 0.0075 }
     ]
    };
    
    mortgageTypeConfig[MORTGAGE_TYPES.CONVENTIONAL_30_YEAR_FIXED] = {
      minDownpayment: 3,
	  months: 360,
      miFactors: [
		{ min: 95.01, max: 97, factor: 0.0043 },
		{ min: 90.01, max: 95, factor: 0.0027 },
		{ min: 85.01, max: 90, factor: 0.0019 },
		{ min: 80.01, max: 85, factor: 0.0012 }
      ]
    };
    
    mortgageTypeConfig[MORTGAGE_TYPES.CONVENTIONAL_15_YEAR_FIXED] = {
      minDownpayment: 3,
	  months: 180,
      miFactors: [
		{ min: 95.01, max: 97, factor: 0.0028 },
		{ min: 90.01, max: 95, factor: 0.0019 },
		{ min: 85.01, max: 90, factor: 0.0014 },
		{ min: 80.01, max: 85, factor: 0.0009 }
      ]
    };
    

	this.initialize = function (element) {
        _this = this;
        this.main = this.$element;

        this.$InteractiveLmpCalculatorForm = this.main.find(".InteractiveLmpCalculator");
        this.$chartContainer = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__chart-container");
        this.$detailsContent = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__details-content");
		this.$legendsContainer = this.$detailsContent.find(".mortgage-legend"); 
        this.$mortgageDetailsContent = this.$InteractiveLmpCalculatorForm.find(".mortage-details .mortgage-details-disclosure");

        this.$collapseToggle = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__collapse-toggle");
        this.$detailsToggle = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__details-toggle");

		this.$principalInterestTooltipBtn = this.$legendsContainer.find('#principleInterestLegend .TooltipBtn--popoverAccordion');
		this.$principleInterest = this.$legendsContainer.find('#principleInterestLegend .amount');
		this.$propertyTax = this.$legendsContainer.find('#propertyTaxLegend .amount');
		this.$mortgageInsurance = this.$legendsContainer.find('#mortgageInsuranceLegend .amount');
		this.$homeInsurance = this.$legendsContainer.find('#homeInsuranceLegend .amount');
		this.$totalMonthlyPayment = this.$chartContainer.find('.InteractiveLmpCalculator__chart-price #monthlyPayment');
		this.APR;
        this.UFMIP;

		this.chartInstance = null;      
        var lastUpdatedField = '';

		var chartColorsData = _this.$chartContainer.data('chartcolors');
		var chartLabelsData = _this.$chartContainer.data('chartlabels');
		var mortgageChartColors = chartColorsData ? chartColorsData.split(',') : [];
		var mortgageChartLabels = chartLabelsData ? chartLabelsData.split(',') : [];

		var propertyTaxCleaned = this.$propertyTax && this.$propertyTax.text() != '' ? cleanNumericInput(this.$propertyTax.text()) : '';
		var homeInsuranceCleaned = this.$homeInsurance && this.$homeInsurance.text() != '' ? cleanNumericInput(this.$homeInsurance.text()) : '';
		var mortgageInsuranceCleaned = this.$mortgageInsurance && this.$mortgageInsurance.text() != '' ? cleanNumericInput(this.$mortgageInsurance.text()) : 0;
		var principleInterestCleaned = this.$principleInterest && this.$principleInterest.text() != '' ? cleanNumericInput(this.$principleInterest.text()) : 0;

		this.propertyTax = propertyTaxCleaned != '' ? parseFloat(propertyTaxCleaned) : 0;
		this.homeInsurance = homeInsuranceCleaned != '' ? parseFloat(homeInsuranceCleaned) : 0;
		this.mortgageInsurance = mortgageInsuranceCleaned != '' ? parseFloat(mortgageInsuranceCleaned) : 0;
		this.principleInterest = principleInterestCleaned != '' ? parseFloat(principleInterestCleaned) : 0;
		
		this.$mortgageChartOptions = {
			values: [this.principleInterest, this.propertyTax, this.homeInsurance, this.mortgageInsurance],
			labels: mortgageChartLabels,
			colors: mortgageChartColors
		};
		
		// Form Elements
		var $salesPriceInput = $('#salesPriceInput');
		var $dollarsInput = $('#dollarPaymentInput');
		var $percentageInput = $('#percentagePaymentInput');
		var $interestRateInput = $('#interestRateInput');
		this.$mortgageTypeInput = $('#mortgageTypeInput');		
		this.$seeResultBtn = $('.InteractiveLmpCalculator__submit-button')

		this.isMobileScreen = window.innerWidth <= 767;

        if (this.isMobileScreen) {
            updateTooltipPlacementsForMobile();
        }

        // Functions to show / hide error message
        var showErrorMessage = function ($field, isDownPaymentField) {
            $field.closest('label').addClass('has-error');
			if(isDownPaymentField){
				$field.closest('.InteractiveLmpCalculator__down-payment').addClass('has-error');
			}
        };
        var clearErrorMessages = function ($field, isDownPaymentField) {
			$field.closest('label').removeClass('has-error');
			if(isDownPaymentField){
				$field.closest('.InteractiveLmpCalculator__down-payment').removeClass('has-error');
			}
        };

		var clearAllValidationErrors = function() {
            var $fields = [ $salesPriceInput, $dollarsInput, $percentageInput, $interestRateInput ];
            // Clear error styles for each
            $fields.forEach(function($field) {
                clearErrorMessages($field, true);
            });
        };

		var handleInputFields = function () {
		    // Remove commas on focus for $salesPriceInput
            $salesPriceInput.on('focus', function () {
                var rawVal = $salesPriceInput.val().replace(/,/g, '');
                $salesPriceInput.val(rawVal);
            });
            
            // Remove commas on focus for $dollarsInput
            $dollarsInput.on('focus', function () {
                var rawVal = $dollarsInput.val().replace(/,/g, '');
                $dollarsInput.val(rawVal);
            });

			// Remove '%' from percentageInput and interestRateInput when user focuses on input
			$percentageInput.on('focus', function () {
				$percentageInput.val($percentageInput.val().replace("%", ""));
			});

			$interestRateInput.on('focus', function () {
				$interestRateInput.val($interestRateInput.val().replace("%", ""));
			});

			// input events 
			$salesPriceInput.on('input', function () {
				var cleanedSalePriceValue = $salesPriceInput.val() != '' ? cleanNumericInput($salesPriceInput.val()) : 0;
				$salesPriceInput.val(cleanedSalePriceValue);
				var salesPriceValue = parseFloat(cleanedSalePriceValue);
			
				if (isNaN(salesPriceValue) || salesPriceValue === 0) {
					salesPriceValue = 0;
					return; // Stop further execution
				}

				if (lastUpdatedField === 'dollars') {
					var cleanedDollarsValue = cleanNumericInput($dollarsInput.val());
					var downPaymentPercentage = (parseFloat(cleanedDollarsValue) / salesPriceValue) * 100;
					$percentageInput.val(Math.round(downPaymentPercentage * 10) / 10 + "%");
				} else if (lastUpdatedField === 'percentage') {
					var downPaymentAmount = (parseFloat($percentageInput.val().replace("%", "")) / 100) * salesPriceValue;
					$dollarsInput.val(cleanOnBlur(downPaymentAmount.toFixed(0), true));
				}
			});
	
			$dollarsInput.on('input', function () {
				lastUpdatedField = 'dollars';
				var dollarValue = $dollarsInput.val() != '' ? cleanNumericInput($dollarsInput.val()) : '0';
				$dollarsInput.val(dollarValue);
				var salesPriceValue = $salesPriceInput.val() != '' ? parseFloat(cleanNumericInput($salesPriceInput.val())) : 0;
				var downpaymentValue = parseFloat(dollarValue);
		
				// Check if the dollar value has 5 characters before the decimal
				if (dollarValue.split('.')[0].length >= 5 && downpaymentValue && salesPriceValue > 0) {
					var downPaymentPercentage = (downpaymentValue / salesPriceValue) * 100;
					$percentageInput.val(Math.round(downPaymentPercentage * 10) / 10 + "%"); // Add %
				}
		
				validateDownpayment();
			});
	
			$percentageInput.on('input', function () {
				lastUpdatedField = 'percentage';
				var percentageValue = $percentageInput.val() != '' ? cleanNumericInput($percentageInput.val()) : '0'; 
				$percentageInput.val(percentageValue);
				var salesPriceValue = $percentageInput.val() != '' ? parseFloat(cleanNumericInput($salesPriceInput.val())) : 0;
				var downpaymentPercent = parseFloat(percentageValue);
		
				if (percentageValue.split('.')[0].length >= 1 && downpaymentPercent && salesPriceValue > 0) {
					var downPaymentAmount = (downpaymentPercent / 100) * salesPriceValue;
					$dollarsInput.val(cleanOnBlur(downPaymentAmount.toFixed(0), true));
				}
				validateDownpayment()
			});
	
			$interestRateInput.on('input', function () {
				var cleanPercentageInputValue = $interestRateInput.val() != '' ? cleanNumericInput($interestRateInput.val()) : '0';
				$interestRateInput.val(cleanPercentageInputValue);
			});

			// Blur events to sync values after focus is lost
			$dollarsInput.on('blur', function () {
				var rawValue = $dollarsInput.val();
				var cleanedNumeric = cleanNumericInput(rawValue);
             	var formattedValue = cleanOnBlur(cleanedNumeric, true, true);

				$dollarsInput.val(formattedValue);
				var salePriceValue = $salesPriceInput.val() != '' ? parseFloat(cleanNumericInput($salesPriceInput.val())) : 0;
				
				var downPaymentValue = parseFloat(cleanedNumeric);
				if (downPaymentValue && salePriceValue > 0) {
					var downPaymentPercentage = (downPaymentValue / salePriceValue) * 100;
					$percentageInput.val(Math.round(downPaymentPercentage * 10) / 10 + "%");
				}

				validateAllFields();
			});
		
			$percentageInput.on('blur', function () {
				var cleanPercentageInputValue = $percentageInput.val() != '' ? cleanOnBlur(cleanNumericInput($percentageInput.val())) : '0';
				var numericValue = parseFloat(cleanPercentageInputValue);
				var salePriceValue = $salesPriceInput.val() != '' ? parseFloat(cleanNumericInput($salesPriceInput.val())) : 0;
			
				if (numericValue && salePriceValue > 0) {
					var downPaymentAmount = (numericValue / 100) * salePriceValue;
					$dollarsInput.val(cleanOnBlur(downPaymentAmount.toFixed(0),true));
				}
			
				if (cleanPercentageInputValue !== "") {
					$percentageInput.val(cleanPercentageInputValue + "%");
				}

				validateAllFields();
			});

			$interestRateInput.on('blur', function () {
				var cleanInterestRateInputValue = $interestRateInput.val() != '' ? cleanOnBlur(cleanNumericInput($interestRateInput.val())) : '';
			
				if (cleanInterestRateInputValue !== "") {
					$interestRateInput.val(cleanInterestRateInputValue + "%");
				}
				validateAllFields();
			});

			// Event listeners for validation on blur
			$('#dollarPaymentInput, #percentagePaymentInput').on('blur', validateDownpayment);
			$salesPriceInput.on('blur', function () {
				var salesPriceInputValue = cleanOnBlur(cleanNumericInput($salesPriceInput.val()),true);
				$salesPriceInput.val(salesPriceInputValue);
	
				validateAllFields()
			});

			$('.mortage-details .LmpCalculatorTooltip').on('keydown', function (e) {
                if (e.key == 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    $('.InteractiveLmpCalculator__modal-close').focus();
                }
            });
		};

		//  validate all fields and handle button state
        var validateAllFields = function () {
            var isSalePriceValid = validateSalePrice();
            var isDownpaymentValid = validateDownpayment();
            var isInterestRateValid = validateInterestRate();
        
            var isFormValid = isSalePriceValid && isDownpaymentValid && isInterestRateValid;
        
            if (!isFormValid) {
                _this.$seeResultBtn.addClass('disabled');
            } else {
                _this.$seeResultBtn.removeClass('disabled');
            }
        };

		// Validate Downpayment Fields (Dollars and Percentage)
		var validateDownpayment = function () {
            var mortgageType = _this.$mortgageTypeInput.val().trim().toLowerCase(); 
            var downpaymentPercentage = $percentageInput.val() != '' ? parseFloat(cleanNumericInput($percentageInput.val())) : 0;
        
            var isConventional = mortgageType.includes('conventional');
            var minRequiredDownpayment = isConventional ? 3 : 3.5;
        
            var isValid = downpaymentPercentage >= minRequiredDownpayment && downpaymentPercentage <= 99.9;
        
            if (!isValid) {
                showErrorMessage($dollarsInput, true);
                showErrorMessage($percentageInput, true);
            } else {
                clearErrorMessages($dollarsInput, true);
                clearErrorMessages($percentageInput, true);
            }
        
        	return isValid;
        };
	
		// Validate Sale Price
		var validateSalePrice = function () {
			var parsedPriceValue = $salesPriceInput.val() != '' ? parseInt(cleanNumericInput($salesPriceInput.val())) : 0; // Remove non-numeric characters

			var isValid = parsedPriceValue >= 100000 && parsedPriceValue <= 9999999;

			if (!isValid) {
				showErrorMessage($salesPriceInput);
			} else {
				clearErrorMessages($salesPriceInput);
			}

			var parsedDollarsVal = $dollarsInput.val() != '' ? parseInt(cleanNumericInput($dollarsInput.val())) : 0;
			var parsedPercentageVal = $percentageInput.val() != '' ? parseInt(cleanNumericInput($percentageInput.val())) : 0;

			if(parsedDollarsVal !== 0 && parsedPercentageVal !== 0){
				validateDownpayment();
			}

			return isValid;
		};
	
		// Validate Interest Rate
		var validateInterestRate = function () {
			var interestRateValue = $interestRateInput.val() != '' ? parseFloat(cleanNumericInput($interestRateInput.val())) : 0;
			
            var isValid = interestRateValue >= 0.001 && interestRateValue <= 99.999;

			if (!isValid) {
				showErrorMessage($interestRateInput);
			} else {
				clearErrorMessages($interestRateInput);
			}
			
			return isValid;
		};

		// Slightly adjust modal scroll position on popover close to prevent visual glitches,
        // such as layout shift or unexpected jump due to scroll recalculation.
		this.$InteractiveLmpCalculatorForm.find('.TooltipBtn--popoverAccordion.LmpCalculatorTooltip')
            .off('hidden.bs.popover')
            .on('hidden.bs.popover', function (e) {
              e.stopPropagation();
              var $modal = $('#interactive-lmp-calculator-modal');
              var currentScroll = $modal.scrollTop();
              $modal.scrollTop(currentScroll - 1);
        });

		this.$seeResultBtn.on("click", function (){
			updateSeeResultLMPStatus()
			calculatePrincipleAndInterest();
			updateTaxesAndInsuranceBySalePrice();
			updateMortgageInsurance();
			updateMortgageChartOptions();
			calculateMortgagePayment();
			renderPieChart();
		})
	
		// reset handler to avoid duplicates
		$('#interactive-lmp-calculator-modal')
		.off('show.bs.modal')
		.on('show.bs.modal', this.handleShowLMPCalculator)
		.off('hidden.bs.modal')
        .on('hidden.bs.modal', function () {
            $(document).trigger('closeAllPopovers');
			clearAllValidationErrors();
			_this.$seeResultBtn.removeClass('disabled');
        });
	
		// Initialize all handlers
		handleInputFields();
		setupToggleDetails();
	}

	this.handleShowLMPCalculator = function (e) {
		var communityId = e.relatedTarget.dataset.communityId;
		var itemType = e.relatedTarget.dataset.itemType;
		var itemId = e.relatedTarget.dataset.itemId;

		if (communityId && itemType && itemId) {
			getItems(communityId, itemType, itemId);
		} else {
			return
		}
	}
	
	function getItems (communityId, itemType, itemId) {
		var apiUrl = itemType.toLowerCase() == "plan" ? '/api/plan/homeplans?communityId=' + communityId
														: '/api/plan/qmiplans?communityId=' + communityId;

		$.ajax({
			type: 'GET',
			context: this,
			// Uncomment for local testing
			//  url: 'https://cdk2.dev.pulte.com' + apiUrl,
			url: apiUrl,
			success: function (response) {
				var apiItem = $(response).filter(function (index, item) {
					if (itemType.toLowerCase() == "qmi") {
						return item.inventoryHomeID == itemId;
					}
					return item.id == itemId;
				})[0];
				if (apiItem) setDefaultValues(apiItem);
			}
		});
	}

	function setDefaultValues (item) {
		if (item.mortgagePayment == null) {
			return;
		}

		var downPaymentDollars = Math.round((item.mortgagePayment.finalPrice * item.mortgagePayment.downPaymentPercentage) / 100);	// Round to whole number
		var downPaymentPercentage = (Math.round(item.mortgagePayment.downPaymentPercentage * 10) / 10).toLocaleString(undefined, {maximumFractionDigits:1});	// Round to 1 decimal place
		var interestRatePercent = (Math.round(item.mortgagePayment.interestRatePercent * 1000) / 1000).toLocaleString(undefined, {maximumFractionDigits:3});	// Round to 3 decimal places

		_this.propertyTax = parseFloat(item.mortgagePayment.monthlyTaxes.toFixed(2));
		_this.homeInsurance = parseFloat(item.mortgagePayment.monthlyInsurance.toFixed(2));

       _this.initialSalePrice = item.mortgagePayment.finalPrice;
       _this.initialPropertyTax = item.mortgagePayment.monthlyTaxes;
       _this.initialHomeInsurance = item.mortgagePayment.monthlyInsurance;
       
       _this.propertyTaxFactor = _this.initialPropertyTax / _this.initialSalePrice;
       _this.homeInsuranceFactor = _this.initialHomeInsurance / _this.initialSalePrice;

		// Set the default values
		$('.InteractiveLmpCalculator__sale-price input').val(formatCurrency(Math.round(item.mortgagePayment.finalPrice), false));	
		$('.InteractiveLmpCalculator__dollars input').val(formatCurrency(downPaymentDollars, false));
		$('.InteractiveLmpCalculator__percentage input').val(downPaymentPercentage + '%');
		$('.InteractiveLmpCalculator__interest-rate input').val(interestRatePercent + '%');
	
	    _this.$principleInterest.text(formatCurrency(Math.round(item.mortgagePayment.totalMonthlyPrincipalAndInterest)));
        _this.$propertyTax.text(formatCurrency(_this.propertyTax));
        _this.$homeInsurance.text(formatCurrency(_this.homeInsurance));
        _this.$mortgageInsurance.text(formatCurrency(Math.round(item.mortgagePayment.monthlyMortgageInsurance)));
        _this.$totalMonthlyPayment.text(formatCurrency(Math.round(item.mortgagePayment.totalMonthlyPayment)));
        _this.APR = item.mortgagePayment.apr;
        _this.UFMIP = item.mortgagePayment.ufmip;
		
		
		_this.$mortgageChartOptions.values = [
            Math.round(item.mortgagePayment.totalMonthlyPrincipalAndInterest),
            _this.propertyTax,
            Math.round(item.mortgagePayment.monthlyInsurance),
            Math.round(item.mortgagePayment.monthlyMortgageInsurance)
        ];
		renderPieChart();
		updateModalContent();
		updateDownpaymentErrorMsg();
	}

	function renderPieChart() {

		var canvas = document.getElementById("mortgageChart"); // Get the canvas element
		if (!canvas) {
			console.error("Canvas element not found!");
			return;
		}
	
        var isExpanded = _this.$chartContainer.hasClass("expanded");
       
        // Set cutoutPercentage: 
		var cutoutSize = isExpanded ? 80 : (_this.isMobileScreen ? 65 : 80);
		var chartData = {
			labels: _this.$mortgageChartOptions.labels,
			datasets: [
				{
					data: _this.$mortgageChartOptions.values,
					backgroundColor: _this.$mortgageChartOptions.colors
				}
			]
		};

		if(_this.chartInstance){
			_this.chartInstance.destroy();
		}
	
		_this.chartInstance = new Chart(canvas.getContext("2d"), {
			type: "doughnut",
			data: chartData,
			options: {
				responsive: true,
				cutoutPercentage: cutoutSize,
				maintainAspectRatio: false,
				legend: {
                    display: false
                },
				tooltips: {
	         	 callbacks: {
	         	 	label: function(tooltipItem, data) {
	         	 		var dataset = data.datasets[tooltipItem.datasetIndex];
	         	 		var value = dataset.data[tooltipItem.index];
	         	 		var label = data.labels[tooltipItem.index] || "";
	         	 		return label + ": $ " + value.toLocaleString();
	         	 	}
	         	 }
	           }
			}
		});
	}

	function setupToggleDetails() {
        _this.$detailsToggle.on("click", function () {
            _this.$chartContainer.addClass("expanded");
            _this.$detailsContent.slideDown();
            
            _this.$detailsToggle.hide();
            _this.$collapseToggle.show();

			 // Manually trigger chart resizing
			 renderPieChart();
			 _this.chartInstance.resize(); 
        });
    
        _this.$collapseToggle.on("click", function () {
            _this.$chartContainer.removeClass("expanded");
            _this.$detailsContent.slideUp();
    
            _this.$collapseToggle.hide();
            _this.$detailsToggle.show();

			 // Manually trigger chart resizing
			 renderPieChart();
			_this.chartInstance.resize();
        });
    }

    function cleanNumericInput(value) {
		if(!value || value.length === 0) return "0";
		if (typeof value !== 'string') return "0";
		
		// Remove all characters except digits and dot	
		value = value.toString().replace(/[^0-9.]/g, ''); // Remove everything except numbers and .
		// Allow only the first decimal point, remove subsequent
		var parts = value.split('.');
		if (parts.length > 2) {
			value = parts[0] + '.' + parts[1];
		}

		// Remove leading zeros unless it's just '0' or '0.xxx'
		value = value.replace(/^0+(?=\d)/, '');

		return value;
    }

	function cleanOnBlur(value, isWholeNumber) {
		if (value.endsWith('.')) {
			return value.slice(0, -1); // remove trailing dot
		}
	    return isWholeNumber ? Math.floor(parseFloat(value)).toLocaleString() : parseFloat(parseFloat(value).toFixed(2));
	}

	function calculateMortgagePayment() {
        
		//Add PI + mortgage insurance + home insurance + property taxes;
		var mortgagePayment = parseFloat(_this.principleInterest) + 
		parseFloat(_this.mortgageInsurance) + parseFloat(_this.homeInsurance) + parseFloat(_this.propertyTax);

		mortgagePayment = mortgagePayment && !isNaN(mortgagePayment) ? Math.round(mortgagePayment) : 0;
		
		_this.$totalMonthlyPayment.text(formatCurrency(mortgagePayment));
    }

	function calculatePrincipleAndInterest(){
		// rate should be in proper decimal notation .0399 for 3.99%
        // Discount Factor = { [ (1 + i)^n] - 1} / [ i(1 + i)^n ]
        // LMP = Amount / Discount Factor
		
		// get months from mortgageType config.
		var mortgageType = (_this.$mortgageTypeInput.val() || "").trim().toLowerCase();
		var months = mortgageTypeConfig[mortgageType].months;

        // Get loan amount
        var salePriceVal = $('.InteractiveLmpCalculator__sale-price input').val();
        var downPaymentVal = $('.InteractiveLmpCalculator__dollars input').val();
        var salePrice = salePriceVal != '' ? parseFloat(cleanNumericInput(salePriceVal)) : 0;
        var downPayment = downPaymentVal != '' ? parseFloat(cleanNumericInput(downPaymentVal)) : 0;
		var loanAmount = salePrice - downPayment;

		// Get interest rate
		var interestRateVal = $('#interestRateInput').val();
        var rate = interestRateVal != '' ? parseFloat(cleanNumericInput(interestRateVal)) : 0;

        var mRate = rate / 100 / 12;
        var numerator = Math.pow(1 + mRate, months) - 1;
        var denominator = mRate * (Math.pow(1 + mRate, months));
        var discountFactor = numerator / denominator;

		//Populate monthly payment
		var principleAndInt = Math.round(loanAmount / discountFactor);
		_this.principleInterest = principleAndInt;
		var principleAndInterestField = $("#principleInterestLegend .amount");
		if(principleAndInterestField){
			principleAndInterestField.text(formatCurrency(principleAndInt));
		}
	}

	function updateTaxesAndInsuranceBySalePrice() {
        var salePriceInput = $('.InteractiveLmpCalculator__sale-price input').val();
        var newSalePrice = salePriceInput ? parseFloat(cleanNumericInput(salePriceInput)) : 0;
    
        if (newSalePrice > 0) {
            _this.propertyTax = parseFloat((newSalePrice * _this.propertyTaxFactor).toFixed(2));
            _this.homeInsurance = parseFloat((newSalePrice * _this.homeInsuranceFactor).toFixed(2));
    
            _this.$propertyTax.text(formatCurrency(_this.propertyTax));
            _this.$homeInsurance.text(formatCurrency(_this.homeInsurance));
        }
    }
	
    function updateMortgageInsurance() {
        var salePrice = parseFloat(cleanNumericInput($('.InteractiveLmpCalculator__sale-price input').val())) || 0;
        var downPayment = parseFloat(cleanNumericInput($('.InteractiveLmpCalculator__dollars input').val())) || 0; 
        var mortgageType = (_this.$mortgageTypeInput.val() || "").trim().toLowerCase(); 
        var insuranceElem = $("#mortgageInsuranceLegend .amount"); 
        var taglineElem = $("#mortgageInsuranceTagline");

        if (!salePrice || !mortgageType) return;

        var loan = salePrice - downPayment;
        var ltv = (loan / salePrice) * 100;
        var mi = 0;
		var config = mortgageTypeConfig[mortgageType];
		var factors = config.miFactors;

        if (mortgageType === MORTGAGE_TYPES.CONVENTIONAL_30_YEAR_FIXED || mortgageType === MORTGAGE_TYPES.CONVENTIONAL_15_YEAR_FIXED) {
            for (var i = 0; i < factors.length; i++) {
                var range = factors[i];
                if (ltv > range.min && ltv <= range.max) {
                    mi = loan * range.factor;
                    break;
                }
            }

            if (taglineElem.length) {
                var depositPercent = (downPayment / salePrice) * 100;
                if (depositPercent >= 20) {
					taglineElem.addClass("show-tagline");
				} else {
					taglineElem.removeClass("show-tagline");
				}
            }
        } else if (mortgageType === MORTGAGE_TYPES.FHA_30_YEAR_FIXED) {
            if (loan <= factors[0].maxLoan) {
                mi = (loan + (loan * (_this.UFMIP / 100))) * factors[0].factor;
            } else {
                mi = (loan + (loan * (_this.UFMIP / 100))) * factors[1].factor;
            }

			taglineElem.removeClass("show-tagline"); // Hide tagline for FHA
        }

		mi = mi / 12;
		_this.mortgageInsurance = Math.round(mi);
		
        if (insuranceElem.length) {
           insuranceElem.text(formatCurrency((_this.mortgageInsurance || 0).toFixed(0)));
        }

		if (_this.$legendsContainer.length) {
			if (mi === 0) {
				_this.$legendsContainer.addClass("zero-mortgage-insuarance");
			} else {
				_this.$legendsContainer.removeClass("zero-mortgage-insuarance");
			}
		}
    }

	function updateModalContent() {
        var $tooltipBtn = _this.$principalInterestTooltipBtn;
        var $mortgageDetails = _this.$mortgageDetailsContent;
    
        var originalTooltipContent = $tooltipBtn.data('original-content');
        var originalMortgageDetailsContent = $mortgageDetails.data('original-content');
    
        // Store original content if not already stored
        if (!originalTooltipContent) {
            $tooltipBtn.data('original-content', $tooltipBtn.attr('data-content'));
        }
    
        if (!originalMortgageDetailsContent) {
            $mortgageDetails.data('original-content', $mortgageDetails.text());
        }
    
        // Update content with dynamic values
        var updatedTooltipContent = replaceDynamicMortgageValues($tooltipBtn.data('original-content'));
        var updatedMortgageDetailsContent = replaceDynamicMortgageValues($mortgageDetails.data('original-content'));
    
        $tooltipBtn.attr('data-content', updatedTooltipContent);
        $mortgageDetails.text(updatedMortgageDetailsContent);
	}
	
	function replaceDynamicMortgageValues(originalContent) {
        var propertyTax = _this.$propertyTax.text() || "";
        var mortgageInsurance = _this.$mortgageInsurance.text() || "";
        var mortgageType = _this.$mortgageTypeInput.val() || "";
		var salePrice = parseFloat(cleanNumericInput($('.InteractiveLmpCalculator__sale-price input').val())).toLocaleString();
        var downPaymentDollars = parseFloat(cleanNumericInput($('.InteractiveLmpCalculator__dollars input').val())).toLocaleString();
        var downPaymentPercent = $('.InteractiveLmpCalculator__percentage input').val().replace('%', '');
        var interestRate = $('.InteractiveLmpCalculator__interest-rate input').val().replace('%', '');
        var loanAmount = Math.round(parseFloat(salePrice) - parseFloat(downPaymentDollars)).toLocaleString();

        return originalContent
            .replace(/\{property tax\}/g, propertyTax)
            .replace(/\{mortgage insurance\}/g, mortgageInsurance)
            .replace(/\{mortgage type\}/g, mortgageType)
            .replace(/\{sale price\}/g, salePrice)
            .replace(/\{loan amount\}/g, loanAmount)
            .replace(/\{down payment\}/g, downPaymentPercent)
            .replace(/\{interest rate\}/g, interestRate)
            .replace(/\{APR\}/g, _this.APR);
	}

	function updateTooltipPlacementsForMobile() {
		_this.$legendsContainer.find('li .TooltipBtn--popoverAccordion')
		.attr('data-placement', 'bottom');
	}
    
    function formatCurrency(amount, withDollarSign) {
        withDollarSign = (typeof withDollarSign === 'undefined') ? true : withDollarSign;
		var formattedAmount = Number(amount).toLocaleString();
        return withDollarSign ? '$' + formattedAmount : formattedAmount;
    }

	function updateMortgageChartOptions() {
		var opts = _this.$mortgageChartOptions.values;
		_this.$mortgageChartOptions.values = [_this.principleInterest, _this.propertyTax, _this.homeInsurance, _this.mortgageInsurance];
	}

	function updateDownpaymentErrorMsg (){
		// Activate corresponding error message span as per mortgage-type
        $(".InteractiveLmpCalculator__down-payment + .error-msg span").removeClass("activate");
	    var mortgageType = _this.$mortgageTypeInput.val().trim().toLowerCase(); 
        var targetSpan = mortgageType.includes('conventional') 
	    ? '.InteractiveLmpCalculator__down-payment + .error-msg span[data-mortgage-type="con"]' 
	    : '.InteractiveLmpCalculator__down-payment + .error-msg span[data-mortgage-type="fha"]';

        $(targetSpan).addClass("activate");
	}

	//  update the status message once for See Result CTA
	function updateSeeResultLMPStatus() {
        var $status = $('#updateSeeResultLMPStatus');
        $status.text('Results have been updated');
      
        // Clear the message after 1 second to avoid repeated announcements on focus
        setTimeout(function(){
          $status.text('');
        }, 1000);
    }
}

module.exports = component(InteractiveLmpCalculator);
